/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {extendTheme} from '@salesforce/retail-react-app/app/components/shared/ui';
import {overrides as baseOverrides} from '@salesforce/retail-react-app/app/theme';

import KitKatPreloader from '@amblique/base/app/theme/components/project/kitkat-preloader';
import PageLoading from '@amblique/base/app/theme/components/project/page-loading';
import Swiper from '@amblique/base/app/theme/components/shared/swiper';
import Video from '@amblique/base/app/theme/components/shared/video';
import borderRadius from '@amblique/base/app/theme/foundations/border-radius';
import breakpoints from '@amblique/base/app/theme/foundations/breakpoints';
import typography from '@amblique/base/app/theme/foundations/typography';
import zIndices from '@amblique/base/app/theme/foundations/z-index';

const {components: baseComponents, ...baseExtensions} = baseOverrides;

export const overrides = {
  ...baseExtensions,

  ...borderRadius,
  ...breakpoints,
  ...typography,
  ...zIndices,

  components: {
    ...baseComponents,

    KitKatPreloader,
    PageLoading,
    Swiper,
    Video,
  },
};

export default extendTheme(overrides);
